module.exports = "  .principal{\n    margin-top: 2px;\n    margin-left: 7%;\n  }"